import { useLocation, useParams } from 'react-router-dom';
import { useCarBySlug } from './useCarData';

export function useJarvisContext() {
    const location = useLocation();
    const params = useParams<{ slug: string }>();
    
    // Fallback: Manually extract slug from pathname if useParams is empty (common in top-level Providers)
    // URL structure is usually /slug or /slug/tab
    const pathParts = location.pathname.split('/').filter(Boolean);
    const manualSlug = pathParts[0] && !['garage', 'settings', 'admin', 'login', 'landing', 'blog', 'audit'].includes(pathParts[0]) 
        ? pathParts[0] 
        : null;
        
    const slug = params.slug || manualSlug;
    const { data: car } = useCarBySlug(slug || '');

    // Determine the view type based on the URL
    const getViewType = () => {
        const path = location.pathname;
        if (path === '/') return 'garage';
        if (path.includes('/dashboard')) return 'dashboard';
        if (path.includes('/expenses')) return 'expenses';
        if (path.includes('/stats')) return 'statistics';
        if (path.includes('/gallery')) return 'gallery';
        if (path.includes('/parts')) return 'parts';
        if (path.includes('/notes')) return 'notes';
        if (path.includes('/repair')) return 'health';
        if (path.includes('/settings')) return 'settings';
        return 'general';
    };

    return {
        currentUrl: window.location.href,
        path: location.pathname,
        carId: car?.id || null,
        carName: car?.name || null,
        viewType: getViewType(),
        slug: slug || null,
    };
}
